import {getTourType} from 'root-packages/tourTypes.js'
import {getDepartureName, getTourName} from '../../packages/departureUtils.js'
import moneyString from '../moneyString.js'


function cartLineFromQuoteCriteria (tour, partyDelta, valueDelta, sellingCompanyCode) {
  const value = moneyString(valueDelta)
  return {
    product: Object.assign({
      id: tour.productCode,
      tourID: tour.tourId,
      name: getTourName(tour),
      category: 'tour',
      quantity: `${partyDelta}`,
      value,
      variants: [
        {
          tourOptionId: tour.tourOptionId,
          name: getDepartureName(tour),
          value,
        },
      ],
    },
    (sellingCompanyCode ? {tourIsKey: `${sellingCompanyCode}-${tour.tourId}-${tour.tourOptionId}`} : {})
    ),
    value,
  }
}

function partyAddToCartEvent (tour, partyDelta, valueDelta, sellingCompanyCode) {
  return {
    event: 'addToCart',
    cart_lines: [cartLineFromQuoteCriteria (tour, partyDelta, valueDelta, sellingCompanyCode)],
  }
}

function partyRemoveFromCartEvent (tour, partyDelta, valueDelta, sellingCompanyCode) {
  return {
    event: 'removeFromCart',
    cart_lines: [cartLineFromQuoteCriteria (tour, partyDelta, valueDelta, sellingCompanyCode)],
  }
}

export default {
  eventsFor: (oldState, newState) => {

    const events = []

    if ( (oldState && oldState.cart.party.size) || (newState && newState.cart.party.size)) {
      const oldPartySize = oldState.cart.party.size
      const newPartySize = newState.cart.party.size

      const oldPartyValue = oldState.cart.party.value
      const newPartyValue = newState.cart.party.value

      if (newPartySize > oldPartySize) {
        const valueDelta = newPartyValue - oldPartyValue
        const partyDelta = newPartySize - oldPartySize
        events.push( partyAddToCartEvent(newState.cart.tourProduct, partyDelta, valueDelta, newState.platform.company_code) )
      } else if (oldPartySize > newPartySize) {
        const valueDelta = oldPartyValue - newPartyValue
        const partyDelta = oldPartySize - newPartySize
        events.push( partyRemoveFromCartEvent(newState.cart.tourProduct, partyDelta, valueDelta, newState.platform.company_code) )
      }
    }

    return events
  },
  cartLinesFor (currentState) {

    const tourProduct = currentState.cart.tourProduct

    let sum = currentState.cart.passengers.reduce((sum,passenger) => sum + passenger.roomPrice, 0)
    sum = sum - currentState.cart.discounts.promotions.amount

    let response = {
      value: moneyString(sum),
      product: {
        id: tourProduct.productCode,
        tourIsKey: `${currentState.platform.company_code}-${tourProduct.tourId}-${tourProduct.tourOptionId}`,
        tourID: tourProduct.tourId,
        name: getTourName(tourProduct),
        shortName: tourProduct.shortTourName,
        category: 'tour',
        subCategory: getTourType(currentState.booking.departure),
        quantity: `${currentState.cart.party.size}`,
        departureId: tourProduct.departureId,
        definiteDeparture: tourProduct.definiteDeparture,
        startDate: tourProduct.startDate,
        endDate: tourProduct.endDate,
        tourDuration: tourProduct.tourDuration,
        value: moneyString(tourProduct.costToReport),
        variant: tourProduct.variant,
        variants: [
          {
            tourOptionId: tourProduct.tourOptionId,
            name: getDepartureName(tourProduct),
            value: moneyString(tourProduct.costToReport),
          },
        ],
      },
    }

    if(currentState.cart.discounts.frequentTravellerDiscount){
      sum = sum - currentState.cart.discounts.frequentTravellerDiscount.amount
      response.value = moneyString(sum)
      response.discount= {
        lines:[
          {
            id:currentState.cart.discounts.frequentTravellerDiscount.name,
            value:moneyString(currentState.cart.discounts.frequentTravellerDiscount.amount),
          },
        ],
        value:moneyString(currentState.cart.discounts.frequentTravellerDiscount.amount),
      }
    }

    return response
  },
}